// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__2WGsg","tableResponsive":"ClientDetail_tableResponsive__x-3uS"};